import { LOGOUT, WHOAMI } from '@/services/api/auth'
import { client } from '@/services/apolloclient'
import { getFeaturehubData } from '@/services/rest-api-featurehub/feature/feature'
import { notificationFetures } from '@/services/rest-api-identity/lib/notification/notification'

export const state = {
  whoami: null,
  modulesNotif: null,
  submoduleNotif: null,
  featureFlag: null,
}

export const mutations = {
  setResource(state, resource) {
    state.whoami = resource
  },
  setModules(state, modules) {
    state.modulesNotif = modules
  },
  setSubmodules(state, modules) {
    state.submoduleNotif = modules
  },
  setFeatureFlag(state, featureFlag) {
    state.featureFlag = featureFlag
  },
}

export const getters = {
  hasAccess: (state) => (scope) => {
    if (state.whoami && state.whoami?.scopes.length == 0) {
      return true
    }
    if (!Array.isArray(scope)) {
      return state.whoami?.scopes.includes(scope)
    }
    for (let i = 0; i < scope.length; i++) {
      if (state.whoami?.scopes.includes(scope[i])) {
        return true
      }
    }
    return false
  },
  hasAccessAll: (state) => (scope) => {
    if (state.whoami && state.whoami?.scopes.length == 0) {
      return true
    }
    if (!Array.isArray(scope)) {
      return state.whoami?.scopes.includes(scope)
    }
    for (let i = 0; i < scope.length; i++) {
      if (!state.whoami?.scopes.includes(scope[i])) {
        return false
      }
    }
    return true
  },
  isWhitelabel: (state) => () => {
    return state.whoami?.isWhitelabel !== undefined ? state.whoami?.isWhitelabel : true
  },
  isParent: (state) => () => {
    return state.whoami?.companyParentId === null
  },
  isNewModule: (state) => (module_alias) => {
    const newModules = state.modulesNotif?.filter((e) => module_alias?.includes(e))
    return newModules?.length > 0
  },
  isNewSubmodule: (state) => (submodule_alias) => {
    const newSubmodules = state.submoduleNotif?.filter((e) => submodule_alias?.includes(e))
    return newSubmodules?.length > 0
  },
  isMetrack: (state) => () => {
    return state.whoami?.isMetrack !== undefined ? state.whoami?.isMetrack : true
  },
  getFeatureFlagData: (state) => (featureFlag) => {
    if (!state.featureFlag) return false
    return state.featureFlag?.find((feature) => feature.key === featureFlag)
  },
  getFeatureFlagValue: (state) => (featureFlag) => {
    const feature = state.featureFlag?.find((feature) => feature.key === featureFlag)
    if (!feature) return false

    const { value, type } = feature

    if (type === 'JSON') return JSON.parse(value)
    if (type === 'BOOLEAN') return value
    if (type === 'NUMBER') return Number(value)

    return value
  },
}

export const actions = {
  init(context) {
    return client
      .query({
        fetchPolicy: 'no-cache',
        manual: true,
        query: WHOAMI,
      })
      .then(({ data }) => {
        context.commit('setResource', data.whoami.whoami)
        return data.whoami.whoami
      })
      .catch((reason) => {
        return {}
      })
  },
  logout() {
    return client
      .mutate({
        fetchPolicy: 'no-cache',
        mutation: LOGOUT,
      })
      .then(({ data }) => {
        return data
      })
      .catch((e) => {
        return {}
      })
  },
  async getNewFeatures(context) {
    const res = await notificationFetures()
    if (!res) return
    const basicModules = ['0a-base-auth', '0b-base-other', '0c-base-system-notification']
    const uniqueModules = []
    const uniqueSubmodules = []
    res.forEach((data) => {
      if (basicModules.includes(data.module)) return
      if (!uniqueModules.includes(data.module)) uniqueModules.push(data.module)
      if (!uniqueSubmodules.includes(data.submodule)) uniqueSubmodules.push(data.submodule)
    })
    context.commit('setModules', uniqueModules)
    context.commit('setSubmodules', uniqueSubmodules)
    return uniqueModules
  },
  async getFeatureFlag(context) {
    const res = await getFeaturehubData()
    if (!res) return
    const featureFlag = []
    res.forEach((data) => featureFlag.push(...data.features))
    context.commit('setFeatureFlag', featureFlag)
  },
}
